import { createPortal } from "react-dom";
import { X, Link2, Type, Heading, Minus, Image as ImageIcon, Youtube, FormInput } from "lucide-react";
import { BlockType } from "../../../types";

const TYPES: { type: BlockType; label: string; hint: string; icon: any; color: string }[] = [
  { type: "link", label: "Link", hint: "Add a link button", icon: Link2, color: "#0ea5e9" },
  { type: "form", label: "Form", hint: "Collect leads into your CRM", icon: FormInput, color: "#7c3aed" },
  { type: "header", label: "Section header", hint: "A heading to group links", icon: Heading, color: "#0d9488" },
  { type: "text", label: "Text", hint: "Add text to your page", icon: Type, color: "#ec4899" },
  { type: "divider", label: "Divider", hint: "A thin separating line", icon: Minus, color: "#64748b" },
  { type: "image", label: "Image", hint: "Place an image (by URL)", icon: ImageIcon, color: "#6366f1" },
  { type: "youtube", label: "YouTube", hint: "Embed a YouTube video", icon: Youtube, color: "#ef4444" },
];

const AddBlockModal = ({
  open,
  onClose,
  onPick,
}: {
  open: boolean;
  onClose: () => void;
  onPick: (t: BlockType) => void;
}) => {
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ink-900/40 backdrop-blur-sm p-4 anim-in overflow-y-auto">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl overflow-hidden my-auto">
        <div className="relative px-6 pt-6 pb-4 border-b border-ink-100">
          <h2 className="font-display text-base font-semibold text-ink-900 tracking-tight">Add to your page</h2>
          <button onClick={onClose} className="absolute top-5 right-5 text-ink-400 hover:text-ink-700 hover:bg-ink-100 w-8 h-8 rounded-lg flex items-center justify-center">
            <X size={16} />
          </button>
        </div>
        <div className="p-5 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {TYPES.map((t) => {
            const Icon = t.icon;
            return (
              <button
                key={t.type}
                onClick={() => onPick(t.type)}
                className="flex items-center gap-3 p-3.5 rounded-xl border border-ink-200 hover:border-ink-300 hover:bg-ink-50/60 text-left transition-colors"
              >
                <span className="w-10 h-10 rounded-xl flex items-center justify-center text-white shrink-0" style={{ background: t.color }}>
                  <Icon size={18} />
                </span>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-ink-900">{t.label}</div>
                  <div className="text-[11px] text-ink-500">{t.hint}</div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AddBlockModal;
